








































import Vue from 'vue'

import type { VForm } from '@/models/Types';
import _users from '@/services/endpoints/users';
import { ExtraAccount } from 'models/ExtraAccount';

export default Vue.extend({
	name: "SecondaryAccountsComp",
	data: () => ({
		dialog: false,
		accounts: [] as ExtraAccount[],
		valid: true,
		accName: '',
		accNameRules: [
			(v: string) => !!v || 'Bitte gib deinen Accountnamen an',
			(v: string) => /^[a-zA-Z\s]+\.\d{4}$/.test(v) || 'Bitte gib einen gültigen Accountnamen an',
		],
	}),
	computed: {
		form: function(): VForm {
			return this.$refs.form as VForm;
		}
	},
	methods: {
		async submit(): Promise<void> {
			if (this.form.validate()) {
				let index = this.accounts.findIndex(acc => acc.accName === this.accName);
				if (index === -1) {
					const id = (await _users.addExtraAccount(this.accName)).id;
					this.accounts.push({ accName: this.accName, id: id });
					this.form.reset();
				}
			}
		},
		async deleteAccount(account: ExtraAccount): Promise<void> {
			await _users.deleteExtraAccount(account.id);
			
			let index = this.accounts.indexOf(account);
			this.accounts.splice(index, 1);
		},
	},
	created: async function(): Promise<void> {
		this.accounts = await _users.getExtraAccounts();
	}
})
